<template>
  <div class="hello">
    <div v-if="ethereumLoaded">
    

    <div v-if="loaded && logged" class="container">
      <menu-off :kind.sync="kind" :isMedic.sync="isMedic"></menu-off>
      <div class="columns">
        <div class="col-ml-auto col-10 view-body col-mx-auto">
          <router-view :isMedic.sync="isMedic"></router-view>
        </div>
        <!-- <div class="col-2">
            <accounts></accounts>
        </div>-->
      </div>
    </div>
    <login v-if="!logged" v-on:logged="onLogin"></login>
    <!-- <div class="login" v-if="loaded && !logged">
      <div class="form-group">
        <h3 v-if="!hasAccount">
          Registrar
        </h3>
        <h3 v-if="hasAccount">
          Login
        </h3>
        <label class="form-label">
          Nombre de usuario
        </label>
        <input class="form-input" v-model="username">
      </div>
      <input type="button" class="btn btn-main float-right" value="Login" v-on:click="login">
    </div>-->
  </div>
      </div>
</template>

<script>
// import accounts from './accounts'
import Menu from "./menu";
// import ContractForm from './contract-form'
import Web3 from "web3";
import Login from "./login";
import gun from "../managers/gun";
var user = gun.user();
import MedicsManager from "../managers/medicsManager";
user.is = null;
// import AuthenticationManager from '../managers/authenticationManager'
export default {
  name: "HelloWorld",
  props: {
    msg: String
  },
  computed: {},
  watch: {
    "user.is": {
      handler() {}
    }
  },
  data() {
    return {
      loaded: true,
      username: "",
      logged: false,
      hasAccount: false,
      kind: "",
      user: user,
      isMedic: false,
      secret: "healthchain",
      ethereumLoaded: false
    };
  },
  methods: {
    onLogin() {
      console.log("on login");
      MedicsManager.GetMedicRegistrationContract(
        process.env.VUE_APP_MEDIC_REGISTRATION
      ).then(async contract => {
        this.medicContract = contract;
        window.web3.eth.getAccounts().then(accounts => {
              var msg = contract.methods.IsMedic(accounts[0]);
        
            console.log("Cuenta usada", accounts[0]);
            window.web3.eth.defaultAccount = accounts[0]
       

          msg.call((i, val) => {
            console.log("is medic?", val);
          this.isMedic = val;
                this.logged = true;
        });
           });
        })
    

    }
  },
  components: {
    // accounts,
    "menu-off": Menu,
    Login
  },
  mounted() {
    this.loaded = !!window.loaded;

    window.addEventListener("load", async () => {
      if (window.ethereum) {
        window.web3 = new Web3(window.ethereum);
        window.ethereum.on("accountsChanged", function() {
          // Time to reload your interface with accounts[0]!
          // location.reload()
        });
        try {
          await window.ethereum.enable();
          this.ethereumLoaded = true;

        } catch (error) {
          console.log(error);
        }
      }
      // Legacy dapp browsers...
      else if (window.web3) {
        window.web3 = new Web3(window.web3.currentProvider);
      }
      // Non-dapp browsers...
      else {
        console.log(
          "Non-Ethereum browser detected. You should consider trying MetaMask!s"
        );
      }
      // this.checkAccount();
      this.loaded = true;

      window.loaded = this.loaded;
    });

    // MedicsManager.GetMedicRegistrationContract(
    //   process.env.VUE_APP_MEDIC_REGISTRATION
    // ).then(async contract => {
    //   var msg = contract.methods.IsMedicPub(gun.user().is.pub);
    //   msg.call((i, val) => {
    //     console.log("is medic?", val);
    //     this.isMedic = val;
    //   });
    // });
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
h3 {
  margin: 40px 0 0;
}
ul {
  list-style-type: none;
  padding: 0;
}
li {
  display: inline-block;
  margin: 0 10px;
}
a {
  color: #42b983;
}

.view-body {
  margin-top: 2em;
}

.login {
  background: white;
  width: 350px;
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  padding: 2em;
}
</style>


